<ng-container *ngIf="agencyInfo$ | async as agencyInfo">
  <div class="c-landing__footer">
    <div class="container container-lg">
      <div class="agency-info left-pane">
        <h4>{{agencyInfo.denominazione}}</h4>
        <div class="contacts">
          <div class="c-landing__icon-label" *ngIf="agencyInfo.email1"><i class="icon-email"></i><span>{{agencyInfo.email1}}</span></div>
          <div class="c-landing__icon-label" *ngIf="agencyInfo.tel1"><i class="icon-phone-shape"></i><span>{{agencyInfo.tel1}}</span></div>
        </div>
      </div>
      <div class="website right-pane">
        <ng-container *ngIf="agencyInfo.sito">
          <h4>Visita il nostro sito web</h4>
          <a class="site-link" [href]="agencyInfo.sito.includes('http') ? agencyInfo.sito : '//' + agencyInfo.sito" target="_blank">{{agencyInfo.sito}}</a>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
